module.exports = __webpack_public_path__ + "static/media/TG4-Logo.2c7bd149.svg";